const notifications = {
  search_contacts: 'Téléphone / Courriel',
  report_type: 'Type de rapport',
  failed_payments_report: 'Rapport des paiements échoués',
  paid_payments_report: 'Rapport des paiements payés',
  failed_recurrings_report: 'Rapport des abonnements échoués',
};

export default notifications;
